"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.light = exports.dark = void 0;
var light = {
  alternate: {
    main: '#f7faff',
    dark: '#edf1f7'
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  mode: 'light',
  primary: {
    main: '#99CC33',
    light: '#7BA7D2',
    dark: '#669900',
    contrastText: '#000'
  },
  secondary: {
    light: '#4784b6',
    main: '#2a6da5',
    dark: '#0e5895',
    contrastText: 'rgba(0, 0, 0, 0.87)'
  },
  text: {
    primary: '#1e2022',
    secondary: '#677788'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#ffffff',
    default: '#ffffff',
    level2: '#f5f5f5',
    level1: '#ffffff'
  }
};
exports.light = light;
var dark = {
  alternate: {
    main: '#1a2138',
    dark: '#151a30'
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff'
  },
  mode: 'dark',
  primary: {
    main: '#99CC33',
    light: '#7BA7D2',
    dark: '#366799',
    contrastText: '#fff'
  },
  secondary: {
    light: '#FFEA41',
    main: '#FFE102',
    dark: '#DBBE01',
    contrastText: 'rgba(0, 0, 0, 0.87)'
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#232C33',
    default: '#222B45',
    level2: '#333',
    level1: '#2D3748'
  }
};
exports.dark = dark;